const width = document
  .querySelector("script[src*=capsearch-leadgenerator]")
  .getAttribute("width");
const ident = document
.querySelector("script[src*=capsearch-leadgenerator]")
.getAttribute("ident");
const version = require("../package.json").version;
const loadjs = require("loadjs");

window.renderApplication = function() {
  var node = document.createElement("leadgenerator-widget");
  node.setAttribute("width", width);
  node.setAttribute("ident", ident);
  document.getElementById('leadgenerator').appendChild(node);
};

window.logToCapsearch = function(msg) {
  if (msg) {
  const xmlhttp = new XMLHttpRequest();
  const url = process.env.VUE_APP_CAPSEARCH_URL + "/api/leadgenerator/v1/logger";
  xmlhttp.open("POST", url);
  xmlhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
  xmlhttp.send(JSON.stringify(msg));
  }
}

window.checkIsActive = async function() {
  let checkUrl = process.env.VUE_APP_CAPSEARCH_URL + '/api/leadgenerator/v1/org-check/' + ident;

  try {
    const response = await fetch(checkUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      }
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    console.log("Active:", data.active);

    if (data.active === "false" && data.message) {
      console.log("Message:", data.message);
      return data.message;
    }

    return true;
  } catch (error) {
    console.error("Fetch error:", error);
  }
};

try {
  (async function() {
    let checkActive = await window.checkIsActive();

    if (checkActive !== true) {
      console.log(checkActive);
      var node = document.createElement("leadgenerator-disabled-widget");
      node.setAttribute("width", width);
      node.setAttribute("ident", ident);

      var message = document.createElement("div");
      message.innerHTML = checkActive;

      node.appendChild(message);
      document.getElementById('leadgenerator').appendChild(node);
    } else {
      var style =
        process.env.VUE_APP_LEADGENERATOR_DIST_URL + "/css/app." + version + ".css";
      var script =
        process.env.VUE_APP_LEADGENERATOR_DIST_URL + "/js/app." + version + ".js";
      loadjs([script, style], "leadgenerator");
      loadjs.ready("leadgenerator", {
        success: function() {
          window.renderApplication();
        },
        async: false,
      });
    }
  })();
} catch (error) {
  window.logToCapsearch({
    message: 'Failed starting the loadjs function',
    error: error
  });
}